import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { app } from "./firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

const messaging = getMessaging(app);

export const requestNotificationPermission = async (userId) => {
    try {
        console.log("Step 1: Checking permission...");

        const permission = await Notification.requestPermission();
        console.log("Permission:", permission);

        if (permission !== "granted") return;

        if (!("serviceWorker" in navigator)) {
            console.log("No service worker support");
            return;
        }

        console.log("Step 2: Registering SW...");
        const registration = await navigator.serviceWorker.register(
            "/firebase-messaging-sw.js"
        );

        console.log("Service Worker Registered:", registration);
        await navigator.serviceWorker.ready;
        console.log("Service Worker Ready");

        console.log("Step 3: Getting token...");
        const token = await getToken(messaging, {
            vapidKey: "BBbs2qLydXzYUaf1BGRaX6WxtWSyAP-o3yfXoSXnuMlmCnLQ9ogPEsKBLMb_3b8MoRbThcyUE6tJtD4d7vxzUx4",
            serviceWorkerRegistration: registration,
        });

        console.log("TOKEN RECEIVED:", token);

        if (!token) {
            console.log("Token is null ❌");
            return;
        }

        await setDoc(
            doc(db, "users", userId),
            {
                fcmToken: token,
                fcmUpdatedAt: serverTimestamp(),
            },
            { merge: true }
        );

        console.log("Token saved to Firestore ✅");

    } catch (error) {
        console.error("Notification error:", error);
    }
};


export const listenForegroundMessages = () => {
    return onMessage(messaging, (payload) => {
        console.log("Foreground message:", payload);

        if (payload?.notification?.body) {
            alert(payload.notification.body);
        }
    });
};
